const list = {
  path: 'list',
  component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/shopCodeAlipay/accessPay/list'], resolve)
}

export default list
